import React, { createContext, useEffect, useState } from 'react'
import { sn_url } from 'utils/js/endpoints'
import { handleError } from 'utils/js/error_helpers'
import { stripGameTabSegments } from 'utils/js/tab_url_helpers'
import BBImage from '../assets/images/ab/sn_ab_bb.jpg'
import BBImage2 from '../assets/images/ab/sn_ab_bb2.jpg'
import BBImage3 from '../assets/images/ab/sn_ab_bb3.jpg'
import LdbrdImage from '../assets/images/ab/sn_ab_ldbrd.jpg'
import LdbrdImage2 from '../assets/images/ab/sn_ab_ldbrd2.jpg'
import LdbrdImage3 from '../assets/images/ab/sn_ab_ldbrd3.jpg'
import store from '../store'

const bbs = [BBImage, BBImage2, BBImage3]
const ldbrds = [LdbrdImage, LdbrdImage2, LdbrdImage3]
const selectedBannerIndex = Math.floor(Math.random() * Math.min(bbs.length, ldbrds.length))
const selectedBigboxBanner = bbs[selectedBannerIndex]
const selectedLeaderboardBanner = ldbrds[selectedBannerIndex]

export const AdsContext = createContext(false)

// GPT setTargeting only accepts string or array-of-string values.
// API responses sometimes include numeric or boolean values — stringify them.
const sanitizeTargeting = targets =>
    Object.fromEntries(
        Object.entries(targets).map(([k, v]) => [k, typeof v === 'number' || typeof v === 'boolean' ? String(v) : v])
    )

export const AdsProvider = ({ children }) => {
    const [ads, setAds] = useState(0)
    const [adTargets, setAdTargets] = useState({})
    const [siteTargetings, setSiteTargetings] = useState({})
    const [adblockIsDetected, setAdblockIsDetected] = useState(false)

    useEffect(() => {
        window.setTimeout(() => {
            if (window._detected) {
                setAdblockIsDetected(window._detected)

                // Handle primary leaderboard Ad banner
                const leaderboardDiv = document.getElementById('leaderboard')
                if (leaderboardDiv) {
                    leaderboardDiv.innerHTML = `<img src=${selectedLeaderboardBanner} alt="Support Sportsnet by disabling your adblocker" style="height: 90px; width: 728px;">`
                }
            }
        }, 3000)
        if (!window.location.pathname.includes('/players')) {
            updateAdTargets().catch(err => {
                handleError(err)
            })
        }
        updateSiteTargeting().catch(err => {
            handleError(err)
        })
    }, [])

    const updateSiteTargeting = () => {
        return fetch(`${sn_url}/wp-json/rsm-adutil/v1/site_targetings/`)
            .then(response => response.json())
            .then(res => {
                setSiteTargetings(res)
                return true
            })
            .catch(err => {
                handleError(err)
                return false
            })
    }
    const updateAdTargets = async (additionalTargets = {}) => {
        let currentURL = sn_url.replace('https://', '')
        // SNWEB-2205: a game page's /:tab?/:videoId? segments are view state —
        // strip them so ad targeting is keyed on the canonical game URL.
        currentURL = currentURL + stripGameTabSegments(window.location.pathname)

        let endpoint = sn_url + '/wp-json/rsm-adutil/v1/get_ad_targets_by_url/' + currentURL

        return fetch(endpoint)
            .then(response => response.json())
            .then(res => {
                // Temporarily set ads data to the window object until we can refactor all ads components to use react context. (TO BE COMPLETED IN NHLWEB-15954)
                const sanitized = sanitizeTargeting({ ...res, ...additionalTargets })
                window.adTargets = function() {
                    return sanitized
                }

                if (res.ad_unit_path) {
                    window.adUnitPath = res.ad_unit_path
                } else {
                    window.adUnitPath = '/7326/en.sportsnet.web/' + res.section
                }
                setAdTargets(sanitized)

                // SNWEB-2205: strip tab segments so a game's Videos TAB
                // (…/games/{code}/videos) doesn't suppress the header ad the
                // way the site-wide /videos section does.
                if (!stripGameTabSegments(window.location.pathname).includes('/videos')) {
                    store.dispatch({
                        type: 'INIT_HEADER_LEADERBOARD_AD',
                        adUnitPath: window.adUnitPath,
                        adTargets: window.adTargets(),
                    })
                }

                return true
            })
            .catch(err => {
                handleError(err)
                return false
            })
    }

    return (
        <AdsContext.Provider
            value={{
                ads,
                setAds,
                siteTargetings,
                adTargets,
                updateAdTargets,
                adblockIsDetected,
                selectedLeaderboardBanner,
                selectedBigboxBanner,
            }}
        >
            {children}
        </AdsContext.Provider>
    )
}

export default AdsContext
